import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TextField',
  props: {
    required: {
      type: Boolean,
      default: true
    },
    showError: {
      type: Boolean,
      default: false
    },
    displayBottom: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    maxlength: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedLabel: function computedLabel() {
      return !this.displayBottom && this.showError && this.errorMessage ? this.errorMessage : this.label;
    },
    errorMsg: function errorMsg() {
      return this.displayBottom && this.errorMessage && this.errorMessage;
    },
    inputClass: function inputClass() {
      return {
        error: this.showError,
        'has-value': this.value,
        'has-label': this.label,
        disabled: this.isDisabled
      };
    }
  }
};